/**
 * @file 邀请活动相关hook
 */
import { useEffect, useState } from 'react';
import { getInviteCode2 } from '@/services';

/**
 * modal相关状态
 */
export const useModal = () => {
  const [isShow, setIsShow] = useState(false);

  const onOpenModal = () => {
    setIsShow(true);
  };

  const onCloseModal = () => {
    setIsShow(false);
  };

  return {
    isShow,
    onOpenModal,
    onCloseModal,
  };
};

/**
 * 获取用户推荐码
 */
export const useRefCode = () => {
  const [refCode, setRefCode] = useState('');

  const fetchInviteCode = async () => {
    try {
      const { code, result } = await getInviteCode2();
      if (code === 0) {
        console.log('fetchInviteCode:', result);
        const code = result.data?.[0]?.code;
        setRefCode(code);
        return code;
      }
    } catch (e) {
      console.error(e);
    }
  };

  useEffect(() => {
    fetchInviteCode();
  }, []);

  return {
    refCode,
  };
};
